import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";

import React from "react";
import { css } from "styled-components";

const enum fields {
    textFieldValue1 = "textFieldValue1",
    textFieldValue2 = "textFieldValue2",
}

interface Props extends WidgetProps {
    fields: {
        [fields.textFieldValue1]: string;
        [fields.textFieldValue2]: string;
    };
}

export interface FooterEndLineStyle {
    container: InjectableCss;
    textFieldValue1?: InjectableCss;
    textFieldValue2?: InjectableCss;
}
export const footerEndLineStyle: FooterEndLineStyle = {
    container: {
        css: css`
            background-color: black;
            border-top: 2px solid black;
            display: flex;
            justify-content: center;
            row-gap: 10px;
            padding: 30px 0px;
            align-items: center;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        max-width: 100%;
                        padding: 20px 20px;
                    `,
                    css`
                        flex-direction: column;
                        max-width: 100%;
                        padding: 20px 20px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    textFieldValue1: {
        css: css`
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            color: white;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 24px;
                        margin-bottom: 14px;
                    `,
                    css`
                        margin-top: 24px;
                        margin-bottom: 14px;
                    `,
                    css`
                        margin-top: 24px;
                        margin-bottom: 14px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    textFieldValue2: {
        css: css`
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            color: white;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: left;
                    `,
                    css`
                        text-align: left;
                    `,
                    css`
                        text-align: center;
                        padding: 0px 26px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
const styles = footerEndLineStyle;

const FooterEndLine: React.FC<Props> = props => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.textFieldValue1}> &#169; {props.fields.textFieldValue1}</StyledWrapper>
            <StyledWrapper {...styles.textFieldValue2}>
                {parse(props.fields.textFieldValue2, parserOptions)}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: FooterEndLine,
    definition: {
        group: "Common",
        displayName: "FooterEndLine",
        fieldDefinitions: [
            {
                name: fields.textFieldValue1,
                displayName: "Text Line 1",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.textFieldValue2,
                displayName: "Text Line 2",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
                isRequired: true,
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
